export const generationRoutes = {
  generation: "/generation",
  generationByFuelType: "/generation-by-fuel-type",
  generationForecast: "/generation-forecast",
  generationForecastForWindAndSolar: "/generation-forecast-for-wind-and-solar",
  interconnectorFlows: "/interconnector-flows",
  windGeneration: "/wind-generation",
  actualGenerationPerType: "/actual-aggregated-generation-per-type",
  actualOrEstimatedWindAndSolarPowerGeneration:
    "/actual-or-estimated-wind-and-solar-power-generation",
  dayAheadAggregatedGeneration: "/day-ahead-aggregated-generation",
};

export const demandRoutes = {
  demand: "/demand",
  rollingSystemDemand: "/rolling-system-demand",
  surplusAndMargin: "/surplus-forecast-and-margin",
  demandForecast: "/demand-forecast",
  demandOutturn: "/demand-outturn",
  dailyEnergyTransmitted: "/daily-energy-transmitted",
  indicativeDemandPeak: "/indicative-peak-demand",
  totalLoadActualAndDayAhead: "/total-load-actual-and-day-ahead",
  totalLoadWeekAhead: "/total-load-week-ahead",
  indicatedForecasts: "/indicated-forecasts",
  restorationZoneDemandForecast: "/restoration-zone-demand-forecast",
  restorationZoneDemandRestored: "/restoration-zone-demand-restored",
};

export const balancingRoutes = {
  balancing: "/balancing",
  shortTermOperatingReserves: "/short-term-operating-reserves",
  bmuView: "/balancing-mechanism-bmu-view",
  marketView: "/balancing-mechanism-market-view",
  adjustmentDataNetbsad: "/adjustment-data-netbsad",
  adjustmentActionsDisbsad: "/adjustment-actions-disbsad",
  marketIndexPrices: "/market-index-prices",
  derivedData: "/derived-data",
  detailedSystemPrices: "/detailed-system-prices",
  systemPrices: "/system-prices",
};

export const noticesRoutes = {
  notices: "/notices",
  creditDefaultNotices: "/credit-default-notices",
  events: "/events",
  settlementMessages: "/settlement-messages",
  sosoTradePrices: "/soso-trade-prices",
};

export const remitRoutes = {
  remit: "/remit",
  remitMessageDetails: "/remit/details",
  remitSubmit: "/remit/submit",
  // TODO #327793: Replace with the real REMIT guidance URL
  remitGuidance: "#",
};

export const transmissionRoutes = {
  transmission: "/transmission",
  rollingSystemFrequency: "/rolling-system-frequency",
  temperature: "/temperature",
  lolpdrm: "/loss-of-load-probability-and-derated-margin",
};

export const accountRoutes = {
  profile: "/profile",
};

const apiDocs = "/api-documentation";

export const apiDocsRouteSuffixes = {
  introduction: "/introduction",
  guidance: "/guidance",
  endpoint: "/endpoint",
  searchResults: "/search-results",
  whatsNew: "/whats-new",
};

export const dataReportsRoutes = {
  dataServices: "/data-services",
  iris: "/iris",
  apiDocs,
  apiDocsIntroduction: apiDocs + apiDocsRouteSuffixes.introduction,
  apiDocsGuidance: apiDocs + apiDocsRouteSuffixes.guidance,
};

const routeConstants = {
  home: "/",
  ...generationRoutes,
  ...demandRoutes,
  ...balancingRoutes,
  ...noticesRoutes,
  ...remitRoutes,
  ...transmissionRoutes,
  ...accountRoutes,
  ...dataReportsRoutes,
  irisLogin: "/iris-login",
};

export const elexonBscDataUrl = "https://www.elexon.co.uk/bsc/data";

export const elexonBscDataConstants = {
  tradingOperationsReport: elexonBscDataUrl + "/trading-operations-report",
  halfHourlySettlementData: elexonBscDataUrl + "/half-hourly-settlement-data",
  systemPricesAnalysisReport:
    elexonBscDataUrl + "/system-prices-analysis-report",
  peerComparisonGraphs: elexonBscDataUrl + "/peer-comparison-graphs",
  grossSupplierMarketShareDataReports:
    elexonBscDataUrl + "/gross-supplier-market-share-data-reports",
  industryStandingData: elexonBscDataUrl + "/industry-standing-data",
  marketDomainData: elexonBscDataUrl + "/market-domain-data",
  openSettlementData: elexonBscDataUrl + "/open-settlement-data",
  dataFlows:
    elexonBscDataUrl +
    "/key-data-reports/data-flows-available-from-bsc-systems",
  openDataRequests: elexonBscDataUrl + "/open-data-requests",
  shortTermOperatingReserveAvailabilityWindow:
    elexonBscDataUrl + "/short-term-operating-reserve-stor-availability-window",
};

export const irisGitHubUrl = "https://github.com/elexon-data/iris-clients";

export const azureStorageAccountUrl =
  "https://azure.microsoft.com/en-gb/products/storage/storage-explorer";

export const elexonBscPortalUrl = "https://www.elexonportal.co.uk/";

export const customerSolutionUrl =
  "https://www.elexon.co.uk/bsc/operational/kinnect-customer-solution/";

export default routeConstants;
